import React, { Fragment } from 'react'
import "./RadioComponent.css";
import { RadioGroup, Radio } from "react-radio-group";
import styled from 'styled-components';
import DOMPurify from "dompurify";
import { Controller } from "react-hook-form"
import { Colors } from "../colors/colors";







export default function RadioComponent({
  selectedValue,
  handleChange,
  name,
  options,
  errorText,
  value,
  onChange,
  control,
  placeholder,
  cName,
  id,
  hasLabel,
  label,
  ...rest
}) {

  const {
    dangerColor
  } = Colors();


  return (
    <RadioGroupComponentWrapper>
      <div
        className="d-flex flex-column"
      >
        {hasLabel && (<label className="form-label" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(label) }} />
        )}

        <Controller
          name={name}
          selectedValue={selectedValue}
          value={value}
          onChange={onChange}
          rules={{ required: true }}
          control={control}
          defaultValue={value}
          className={cName}
          render={({ field: { onChange, onBlur, ref } }) => (

            <RadioGroup
              name={name}
              selectedValue={selectedValue}
              value={value}
              onChange={handleChange}
              onBlur={onBlur}
              ref={ref}
            >
              <RadioGroupWrapper

                style={{
                  flexDirection: "column",
                  gap: "1rem"
                }}

              >
                {options?.map((option) => (
                  <Fragment
                    key={option.label}
                  >
                    <Label>
                      <Radio
                        value={option.value}
                        {...rest}
                        className="custom-radio"
                        id="accent"
                        checked={selectedValue === option.value}
                        style={{
                          cursor: "pointer"
                        }}
                      />
                      {option.label}
                    </Label>
                  </Fragment>
                ))}
              </RadioGroupWrapper>
            </RadioGroup>

          )}
        />

      </div>
      {errorText && <small
        style={{
          margin: 0,
          color: dangerColor
        }}
      >
        {errorText || ""}
      </small>
      }
    </RadioGroupComponentWrapper>
  )
}


const RadioGroupComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 1rem;
`;

const RadioGroupWrapper = styled.div`
	display: flex;
	flex-direction: row;
	gap: 2rem;
  cursor: pointer;
`;

const Label = styled.label`
	display: flex;
	align-items: center;
	flex-direction: row;
	gap: 8px;
`;
